import React, { useState, useRef, useEffect } from 'react'
import Plus from '../icons/Plus'
import ButtonWithLoader from './ButtonWithLoader'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'
import { CLEAR_UPLOADED_IMAGE, UPLOAD_IMAGE } from '../redux/manageSlidesReducer'

const AddImageModal = ({ onClose }: { onClose: () => void }) => {
  const [image, setImage] = useState<string | null>(null)
  const fileInputRef = useRef<HTMLInputElement>(null)
  const uploadedImage = useSelector((state: RootReducer) => state.manageSlidesReducer.uploadedImage)
  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      dispatch(CLEAR_UPLOADED_IMAGE())
    }
  }, [dispatch])

  return (
    <div>
      <div className="h-20" />
      <div className="bg-white rounded-md p-4 max-w-[27rem] w-screen">
        <h2 className="text-24 font-semibold">Add Image</h2>
        <div className="flex flex-col gap-4 mt-4">
          <div className="flex justify-center">
            <div onClick={() => fileInputRef.current?.click()} className="cursor-pointer">
              <input
                onChange={(e) => {
                  const file = e.target.files?.[0]
                  const reader = new FileReader()
                  reader.onload = (e) => {
                    const base64String = e.target?.result
                    setImage(base64String as string)
                  }
                  if (file) {
                    reader.readAsDataURL(file)
                  }
                }}
                type="file"
                ref={fileInputRef}
                className="hidden"
                accept=".jpg, .jpeg, .png"
              />
              {image ? (
                <img className="w-24 h-24 border-2 border-slateGray" src={image ?? ''} alt="Add" />
              ) : (
                <div className="text-slateGray w-24 h-24 rounded-full border-2 border-slateGray flex items-center justify-center">
                  <Plus />
                </div>
              )}
              <div className="h-3" />
              <button className="font-sans text-16 font-semibold text-slateGray border-2 border-slateGray rounded-lg p-4">
                Upload
              </button>
            </div>
          </div>
          {uploadedImage && (
            <textarea
              value={`<img style="width: 800px; margin-top: 20px;" src="${uploadedImage}"></img>`}
              onChange={() => null}
              className="border-2 border-gray-300 rounded-md p-2 text-[10px] h-10"
            />
          )}
        </div>
        <div className="flex justify-between mt-4">
          <div className="w-24">
            <ButtonWithLoader label="Close" onClick={onClose} />
          </div>
          <button
            onClick={() => dispatch(UPLOAD_IMAGE({ base64Image: image ?? '' }))}
            className="bg-slateGray px-4 py-2 rounded-md text-white font-semibold">
            Submit
          </button>
        </div>
      </div>
    </div>
  )
}

export default AddImageModal
